import { render } from "./BackgroundAudio.vue?vue&type=template&id=2486dd8b&scoped=true"
import script from "./BackgroundAudio.vue?vue&type=script&lang=js"
export * from "./BackgroundAudio.vue?vue&type=script&lang=js"

import "./BackgroundAudio.vue?vue&type=style&index=0&id=2486dd8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2486dd8b"]])

export default __exports__